const Memberships=[
    { 
        type:"Default",
        prices:[
           {
            month:"1",
            amount:"2000",
           },
           {
            month:"3",
            amount:"5500",
           },
           {
            month:"6",
            amount:"11500"
           }
        ],
        benefits:["Gym equipments","shower"]
    
    },
    {
        type:"Gold",
        prices:[
           {
            
            month:"1",
            amount:"2600",
           },
           {
            month:"3",
            amount:"7800",
           },
           {
            month:"6",
            amount:"13500"
           }
        ],
        benefits:["Gym equipments","shower","juice"]
    }    
];

export default Memberships;
